import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { SampleTag } from "../components/SampleTag";
import { EXAMS, QUESTION_DIFFICULTY } from "../data/sampleData";

const difficultyClass = (d) =>
    d === "hard"
        ? "border-brass text-brass"
        : "border-line text-ink-muted";

const Exams = () => (
    <main className="py-20 md:py-28" data-testid="exams-page">
        <div className="wrap">
            <Reveal className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
                <div>
                    <p className="eyebrow">Exams</p>
                    <h2 className="mt-4 max-w-2xl text-3xl leading-tight tracking-tight sm:text-4xl lg:text-5xl">
                        Three boards. <em className="italic text-brass">One standard.</em>
                    </h2>
                </div>
                <SampleTag />
            </Reveal>

            <div className="mt-16">
                {EXAMS.map((exam, idx) => (
                    <Reveal key={exam.id}>
                        <article
                            className="border-t border-line py-14 md:py-16"
                            data-testid={`exam-card-${exam.id}`}
                        >
                            <div className="grid gap-10 lg:grid-cols-2 lg:gap-16">
                                <div>
                                    <p className="text-[11px] font-medium uppercase tracking-[0.2em] text-brass">
                                        {exam.shortName}
                                    </p>
                                    <h3 className="mt-3 text-2xl tracking-tight sm:text-3xl">
                                        {exam.name}
                                    </h3>

                                    <dl className="mt-8 space-y-3">
                                        {exam.pattern.map((p) => (
                                            <div
                                                key={p}
                                                className="flex items-baseline gap-3 text-sm text-ink-muted"
                                            >
                                                <span className="inline-block h-1 w-1 shrink-0 rotate-45 bg-brass" />
                                                {p}
                                            </div>
                                        ))}
                                    </dl>

                                    <p className="mt-8 text-[11px] font-medium uppercase tracking-[0.2em] text-ink-muted">
                                        Typical panel
                                    </p>
                                    <p className="mt-3 max-w-md text-sm leading-relaxed text-ink-muted">
                                        {exam.panel}
                                    </p>

                                    <Link
                                        to="/book"
                                        data-testid={`book-this-board-${exam.id}`}
                                        className="u-link mt-8 inline-flex items-center gap-2 text-sm tracking-wide text-ink transition-colors duration-300 hover:text-brass"
                                    >
                                        Book this board
                                        <ArrowRight size={14} strokeWidth={1.5} />
                                    </Link>
                                </div>

                                <div className="lg:border-l lg:border-line lg:pl-16">
                                    <p className="text-[11px] font-medium uppercase tracking-[0.2em] text-ink-muted">
                                        Three sample questions
                                    </p>
                                    <ol className="mt-5">
                                        {exam.questions.map((q, i) => {
                                            const difficulty = (QUESTION_DIFFICULTY[exam.id] || [])[i];
                                            return (
                                                <li
                                                    key={q}
                                                    className={`py-5 ${i !== exam.questions.length - 1 ? "border-b border-line" : ""}`}
                                                >
                                                    <p className="font-display text-lg leading-snug sm:text-xl">
                                                        <span className="mr-4 text-sm italic text-brass tabular-nums">
                                                            0{i + 1}
                                                        </span>
                                                        “{q}”
                                                        {difficulty && (
                                                            <span
                                                                className={`ml-3 inline-block border px-2 py-0.5 align-middle text-[10px] uppercase tracking-widest ${difficultyClass(difficulty)}`}
                                                                data-testid={`difficulty-${exam.id}-${i}`}
                                                            >
                                                                {difficulty}
                                                            </span>
                                                        )}
                                                    </p>
                                                </li>
                                            );
                                        })}
                                    </ol>
                                    <p className="mt-4 text-xs text-ink-muted">
                                        Difficulty auto-scored by Jev on the Universal Key.
                                    </p>
                                </div>
                            </div>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </main>
);

export default Exams;
